export default "__VITE_ASSET__BVjOmHVx__"